import HandleInsertInputChangeUsuario from './HandleInsertUserInputChange';
import HandleInsertInputChangeEmpresa from './HandleInsertInputChangeEmpresa';
import HandleInsertInputChangeProyecto from './HandleInsertInputChangeProyecto';

let handleInsertInputChange = (event, This) => {

  let usuario = event.target.dataset.usuario,
      empresa = event.target.dataset.empresa,
      proyecto = event.target.dataset.proyecto

  //console.log(empresa)

  if(usuario !== undefined){
    HandleInsertInputChangeUsuario(event, This)
  }else if(empresa !== undefined){
    HandleInsertInputChangeEmpresa(event, This)
  }else if(proyecto !== undefined){
    HandleInsertInputChangeProyecto(event, This)
  }

  return null

}

export default handleInsertInputChange;
